"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var initialRecipientCacheStore = {
    recipientCache: null,
};
var store = satcheljs_1.createStore('recipientcache', initialRecipientCacheStore)();
exports.default = store;
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-cache/lib/store/store.js
// module id = 2620
// module chunks = 2 3 4 15 26 45 46 63 68